import styled from 'foundations-theming/utils';

/**
 * A simple skeleton ui for text which is currently loading; shows a gray bar.
 * It's approximately the height of average text in the current font size (0.8em),
 * so it looks sort of like text when you squint.
 *
 * Example:
 *   <SkeletonText />
 *
 * See https://git.hubteam.com/HubSpot/conversations-skeleton-state
 */
export const SkeletonText = styled.div.withConfig({
  displayName: "SkeletonText",
  componentId: "sc-1yeg8kp-0"
})(["background-color:", ";border-radius:999px;display:inline-block;height:0.8em;width:6em;"], ({
  theme,
  use
}) => use === 'form-on-dark' ? theme.color['fill-tertiary-subtle'] : theme.color['fill-tertiary-default']);